import React, { useState, useEffect } from "react";
import axios from "axios";
import { useShop } from "../context/ShopContext"; // Custom hook for shop data context
import * as XLSX from "xlsx";
import { saveAs } from 'file-saver';
import { FaSpinner } from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';




const Report = () => {
  const { shopId, token } = useShop(); 
  const [expenses, setExpenses] = useState([]); 
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null); 
  const [search, setSearch] = useState(null); 




const showToast = (message, type = "error") => {
  
      toast.dismiss(); 
    
      console.log("Toast Type:", type); 
    
      if (type.toLowerCase() === "error") {
        toast.error(message);
      } else if (type.toLowerCase() === "success") {
        toast.success(message);
      } else {
        console.warn("Invalid toast type:", type);
      }
    };







useEffect(() => {
    const fetchExpenses = async () => {
      try {
        setLoading(true);
        const response = await axios.post(
          "https://winenew.sipstocks.in/api/Liquor/GetExpenseReport",
          { shopId: shopId },
          {
            headers: {
              Accept: "*/*",
              Authorization: `Bearer ${token}`, // Using token from context
              "Content-Type": "application/json",
            },
          }
        );
        console.log("GetExpenseReport", response);

        if (response.data && response.data.code === 200) {
          setExpenses(response.data.data || []);
        } else {
          setError("Unexpected response format.");
        }
      } catch (err) {
        console.error("Error fetching expense report:", err);
        setError("Unable to fetch expense data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    if (shopId && token) {
      fetchExpenses();
    }
  }, [shopId, token]);



  // Function to export data to Excel
  const exportToExcel = () => {
    if (!expenses || expenses.length === 0) {
      showToast("No data to export!","error");
      return;
    }
  
    try {
      // Step 1: Convert JSON data to an Excel worksheet
      const worksheet = XLSX.utils.json_to_sheet(
        expenses.map((expense, index) => ({
          "S. No.": index + 1, // Serial Number
          "Amount": expense.amount,
          "Shop Name": expense.shopName,
          "Expense Name": expense.expName,
          "Expense Date": expense.expenseDate || "N/A",
          "User Name": expense.userName,
        }))
      );
  
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Expense Report");
  
      // Step 2: Generate Excel file as a Blob
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
  
      // Step 3: Check if iOS 12 or lower and use alternative method
      const isOldIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.Promise;
  
      if (isOldIOS) {
        // Convert Excel file to base64 URI
        const reader = new FileReader();
        reader.onload = function () {
          const link = document.createElement("a");
          link.href = reader.result;
          link.download = "Expense_Report.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        };
        reader.readAsDataURL(data);
      } else {
        // For iOS 13+, Android, Windows, Mac (uses `saveAs`)
        saveAs(data, "Expense_Report.xlsx");
      }
  
      showToast("Data exported successfully!","success");
    } catch (error) {
      console.error("Error exporting data:", error);
      showToast("Failed to export data.","error");
    }
  };
  





  return (
    
     <div className="app-main flex-column flex-row-fluid" id="kt_app_main">
         
          <div className="d-flex flex-column flex-column-fluid">
              {/* Toolbar */}
              <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                  {/* Toolbar container */}
                  <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                      {/* Page title */}
                      <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                          {/* Title */}
                          <h1 className="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0">
                          Expense Report
                          </h1>
                          <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                              <li className="breadcrumb-item text-muted">
                                  <a href="index.html" className="text-muted text-hover-primary">Home</a>
                              </li>
                              <li className="breadcrumb-item">
                                  <span className="bullet bg-gray-500 w-5px h-2px"></span>
                              </li>
                              <li className="breadcrumb-item text-muted">Dashboards</li>
                          </ul>
                      </div>
                  </div>
              </div>
        
              <div id="kt_app_content" className="app-content flex-column-fluid">
                  <div id="kt_app_content_container" className="app-container container-fluid">
                      <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
                          <div className="col-xl-12">
                              <div className="card card-flush h-md-100">
                                   <ToastContainer />
                                 
                                  <div className="card-body pt-6">
                                  <div className="panel-heading">

<button
onClick={exportToExcel}
  className="btn btn-success export-btn"
    >
   Export to Excel
</button>
</div>
                                  <div className="table-responsive">
                            {loading ? (
                                                                                            <div className="loader-container">
                                                                                                <FaSpinner className="spinner-icon" />
                                                                                            </div>
                        ) : expenses.length > 0 ? (
                          <table className="table table-bordered table-striped">
                            <thead>
                              <tr>
                                <th>S. No.</th> 
                                <th>Amount</th>
                                <th>Shop Name</th>
                                <th>Expense Name</th>
                                <th>Expense Date</th>
                                <th>User Name</th>
                              </tr>
                            </thead>
                            <tbody>
                              {expenses.map((expense, index) => (
                                <tr key={expense.id}>
                                  <td>{index + 1}</td> {/* Dynamically calculated Serial Number */}
                                  <td>{expense.amount}</td>
                                
                                  <td>{expense.shopName}</td>
                                  <td>{expense.expName}</td>
                                  <td>{expense.expenseDate || "N/A"}</td>
                                  <td>{expense.userName}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        ) : (
                          <p>No expenses found.</p>
                        )}
                      </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        
          {/* Footer */}
          <div id="kt_app_footer" className="app-footer">
              <div className="app-container container-fluid d-flex flex-column flex-md-row flex-center flex-md-stack py-3">
                  <div className="text-gray-900 order-2 order-md-1">
                      <span className="text-muted fw-semibold me-1">2025&copy;</span>
                      <a href="#" target="_blank" className="text-gray-800 text-hover-primary">WineShop</a>
                  </div>
              </div>
          </div>
        </div>
        </div>
  );
};

export default Report;
